import type { TabData } from "rc-dock";
import { parseTabId } from "@/contexts/tabsContext";
import { TabTitle } from "@/chat2/components/chatlayout/TabTitle";
import { PreviewBrowserTab } from "./PreviewBrowserTab";

export const PreviewBrowserTabRenderer = (id: string): TabData => {
  const { entityId } = parseTabId(id);
  const workspaceId = entityId ?? "";
  return {
    id,
    title: <TabTitle id={id} />,
    content: <PreviewBrowserTab workspaceId={workspaceId} tabId={id} />,
  };
};
